var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1B1CD",
    d: "M55.5 10.34h-39C7.391 10.35.01 17.732 0 26.84v3a1.5 1.5 0 0 0 1.5 1.5h69a1.5 1.5 0 0 0 1.5-1.5v-3c-.01-9.108-7.391-16.49-16.5-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616B7A",
    d: "m65.542 19.995-6.86-13.722C55.88.67 49.066-1.601 43.462 1.2q-.152.076-.302.157L9.852 19.29a1.62 1.62 0 0 0 .768 3.046h53.473a1.62 1.62 0 0 0 1.449-2.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__b)",
    d: "M10.5 14.961h51c5.799 0 10.5 5.105 10.5 11.402v32.576c0 6.297-4.7 11.401-10.5 11.401h-51C4.7 70.34 0 65.236 0 58.94V26.363c0-6.297 4.7-11.402 10.5-11.402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__c)",
    d: "M70.5 31.34h-12c-5.799.003-10.498 4.707-10.495 10.506.003 5.795 4.7 10.491 10.495 10.494h12a1.5 1.5 0 0 0 1.5-1.5v-18a1.5 1.5 0 0 0-1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.5 46.34a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet_svg__b",
    x1: 36,
    x2: 36,
    y1: 14.961,
    y2: 70.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CCE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet_svg__c",
    x1: 52.262,
    x2: 73.506,
    y1: 31.34,
    y2: 53.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8598B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
};
export default SvgWallet;